export interface IFontFamilyDefaults {
    global: {
        name: string;
        path: string;
    };
}

export const fontFamilyDefaults: IFontFamilyDefaults = {
    global: {
        name: 'PlayBold',
        path: '/../_shared/fonts/Play-Bold.ttf'
    }
};
